var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.displayBalance)?_c('a',{staticClass:"app-menu__link-item balance-btn",class:{
      'color-mode': _vm.colorMode,
      'negative': _vm.balance < 0,
      'positive': _vm.balance > 0,
   },attrs:{"href":"#","title":"Баланс и пополнение счета"},on:{"click":function($event){$event.preventDefault();return _vm.openPopup()}}},[_c('span',{staticClass:"menu-icon"},[_c('icon',{attrs:{"name":"app-balance"}})],1),_c('span',{staticClass:"app-menu__link-item-title"},[_vm._v("Баланс и пополнение счета")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }